export const MEDIA_TYPES = {
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  DOCUMENT: 'DOCUMENT',
};

export const MEDIA_CONFIGS = {
  IMAGE: {
    type: MEDIA_TYPES.IMAGE,
    acceptedFormats: ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'],
    extensions: '.jpeg,.png,.jpg,.gif',
    maxFileSize: 5 * 1024 * 1024,
    label: 'Image (JPEG, PNG, JPG, GIF)',
    maxSizeText: 'Max 5MB',
    requiresCaption: false,
  },
  AUDIO: {
    type: MEDIA_TYPES.AUDIO,
    acceptedFormats: ['audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/mp3'],
    extensions: '.mp3,.wav,.ogg',
    maxFileSize: 16 * 1024 * 1024,
    label: 'Audio (MP3, WAV, OGG)',
    maxSizeText: 'Max 16MB',
    requiresCaption: false,
  },
  VIDEO: {
    type: MEDIA_TYPES.VIDEO,
    acceptedFormats: ['video/mp4', 'video/avi', 'video/quicktime', 'video/x-msvideo'],
    extensions: '.mp4,.avi,.mov,.mkv',
    maxFileSize: 16 * 1024 * 1024,
    label: 'Video (MP4, AVI, MOV, MKV)',
    maxSizeText: 'Max 16MB',
    requiresCaption: true,
  },
  DOCUMENT: {
    type: MEDIA_TYPES.DOCUMENT,
    acceptedFormats: [
      'application/pdf',
      'text/plain',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
    extensions: '.pdf,.txt,.doc,.docx',
    maxFileSize: 100 * 1024 * 1024,
    label: 'Document (PDF, TXT, DOC, DOCX)',
    maxSizeText: 'Max 100MB',
    requiresCaption: true,
  },
};

export const validateMediaFile = (file, mediaType) => {
  if (!file) {
    return { valid: false, error: 'No file selected' };
  }

  const config = MEDIA_CONFIGS[mediaType];
  if (!config) {
    return { valid: false, error: `Invalid media type: ${mediaType}` };
  }

  if (!config.acceptedFormats.includes(file.type)) {
    return {
      valid: false,
      error: `Invalid file type. Expected ${config.label}`,
    };
  }

  if (file.size > config.maxFileSize) {
    return {
      valid: false,
      error: `File size exceeds ${config.maxSizeText} limit`,
    };
  }

  return { valid: true };
};
